import { ticketsService } from '../../helpers/backend/tickets.service';

export const state = {
    addTicket: null,
    tickets: {},
    ticket: {},
    ticketActions: {},
    ticketCauses: {},
}

export const getters = {
    getTickets(state) {
        return state.tickets
    },
    getTicket(state) {
        return state.ticket
    },
    getTicketActions(state){
        return state.ticketActions
    },
    getTicketCauses(state){
        return state.ticketCauses
    },
}

export const actions = {
    getTicketsBy({ commit }, params) {
        return ticketsService.getTickets(params)
            .then(
                tickets => {
                    commit("GET_TICKETS_SUCCESS", tickets);
                    return Promise.resolve(tickets)
                },
                error => {
                    return Promise.reject(error)
                }
            );
    },
    getTicketInfos({ commit }, params) {
        return ticketsService.getTicket(params)
            .then(
                ticket => {
                    commit("GET_TICKET_SUCCESS", ticket);
                    return Promise.resolve(ticket)
                },
                error => {
                    return Promise.reject(error)
                }
            );
    },
    getTicketActionsBy({ commit }, id) {
        return ticketsService.getTicketActions(id)
            .then(
                ticketActions => {
                    commit("GET_TICKETSACTIONS_SUCCESS", ticketActions);
                    return Promise.resolve(ticketActions)
                },
                error => {
                    return Promise.reject(error)
                }
            );
    },
    getTicketCausesBy({ commit }, id){
        return ticketsService.getTicketCauses(id)
            .then(
                ticketCauses => {
                    commit("GET_TICKETSCAUSES_SUCCESS", ticketCauses);
                    return Promise.resolve(ticketCauses)
                },
                error => {
                    return Promise.reject(error)
                }
            );
    },
    addTicket({ commit }, params) {
        return ticketsService.addTicket(params)
            .then(
                ticket => {
                    commit("ADD_TICKET_SUCCESS", ticket)
                    return Promise.resolve(ticket);
                },
                error => {
                    return Promise.reject(error)
                }
            );
    },
    updateTicket({ commit }, params) {
        return ticketsService.updateTicket(params)
            .then(
                ticket => {
                    commit("UPDATE_TICKET_SUCCESS", ticket)
                    return Promise.resolve(ticket);
                },
                error => {
                    return Promise.reject(error)
                }
            );
    },
    delTicket({ commit }, id) {
        return ticketsService.delTicket(id)
            .then(
                ticket => {
                    commit("DEL_TICKET_SUCCESS", id)
                    return Promise.resolve(ticket);
                },
                error => {
                    return Promise.reject(error);
                }
            );
    },
    clearTickets({ commit }) {
        commit("CLEAR_TICKETS")
    },
};

export const mutations = {
    GET_TICKETS_SUCCESS(state, tickets) {
        state.tickets = tickets;
    },
    GET_TICKET_SUCCESS(state, ticket) {
        state.ticket = ticket;
    },
    GET_TICKETSACTIONS_SUCCESS(state, ticketActions) {
        state.ticketActions = ticketActions;
    },
    GET_TICKETSCAUSES_SUCCESS(state, ticketCauses) {
        state.ticketCauses = ticketCauses;
    },
    ADD_TICKET_SUCCESS(state, ticket) {
        state.addTicket = ticket
    },
    UPDATE_TICKET_SUCCESS(state, ticket){
        if(state.tickets.results){
            let results = state.tickets.results.map(obj => obj.id == ticket.id ? ticket : obj)
            state.tickets = {...state.tickets, results: results}
        }
    },
    DEL_TICKET_SUCCESS(state, id){
        let results = state.tickets.results.filter(obj => obj.id != id)
        state.tickets = {...state.tickets, results: results}
    },
    CLEAR_TICKETS(state) {
        state.tickets = {}
    },
};